import { MainContainer } from "./components/containers/MainContainer";
import "./components/Rick.css";

export default function App() {
  return (
    <>
      <MainContainer />
    </>
  );
}
